import RoutesApp from "./routes";

/**
 * Toastfy - loader 
 * https://fkhadra.github.io/react-toastify/installation
 * yarn add react-toastify
 */
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      <ToastContainer autoClose={3000} />
      <RoutesApp />
    </div>
  );
}

export default App;
